// Single source for the per-platform permission fields on a user record.
// Keep in sync with server/models/usersModel.js.
export const PERMISSIONS = [
  { key: "sFass", label: "sFass", width: 120 },
  { key: "reconciliation", label: "Reconciliation", width: 150 },
  { key: "assets", label: "Assets", width: 120 },
  { key: "stock", label: "Stock", width: 120 },
  { key: "portfolio_manager", label: "P.Manager", width: 140 },
  { key: "risk_manager", label: "Risk Manager", width: 150 },
  { key: "e_claim", label: "eClaim", width: 120 },
  { key: "e_advice", label: "eAdvice", width: 120 },
  { key: "shares", label: "Shares", width: 120 },
  { key: "hr", label: "hr", width: 110 },
];

export const ACCESS_LEVELS = [
  "Read-Write",
  "Read Only",
  "Administrator",
  "Approver",
  "Restricted",
  "Payer",
];

export const YES_NO = ["yes", "no"];

// Picks every permission field (plus HR/payroll rights) from form values.
export function pickPermissions(values) {
  return {
    ...PERMISSIONS.reduce((acc, permission) => {
      acc[permission.key] = values[permission.key];
      return acc;
    }, {}),
    hr_permission: values.hr_permission,
    payroll_permission: values.payroll_permission,
  };
}
